import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import teamReducer from './team.reducer';
import proposalReducer from './proposal.reducer';
import qprReducer from './qpr.reducer';
import qprDataReducer from './qpr_data.reducer';
import mprReducer from './mpr.reducer';

const appReducer = combineReducers({
  auth: authReducer,
  team: teamReducer,
  proposal: proposalReducer,
  qpr: qprReducer,
  qpr_data: qprDataReducer,
  mpr: mprReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export default rootReducer;